/**
 * `flip_faces` as `PrimitiveMesh::_update` applies it after the builder
 * (`scene/resources/3d/primitive_meshes.cpp:76-98`): it negates every normal and swaps the first
 * two corners of each triangle. Positions, UVs and tangents stay, and so does the AABB.
 *
 * Derived from Godot Engine (`scene/resources/3d/primitive_meshes.cpp`), used under the MIT licence:
 *
 *   Copyright (c) 2014-present Godot Engine contributors (see AUTHORS.md).
 *   Copyright (c) 2007-2014 Juan Linietsky, Ariel Manzur.
 *
 *   Permission is hereby granted, free of charge, to any person obtaining
 *   a copy of this software and associated documentation files (the
 *   "Software"), to deal in the Software without restriction, including
 *   without limitation the rights to use, copy, modify, merge, publish,
 *   distribute, sublicense, and/or sell copies of the Software, and to
 *   permit persons to whom the Software is furnished to do so, subject to
 *   the following conditions:
 *
 *   The above copyright notice and this permission notice shall be
 *   included in all copies or substantial portions of the Software.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 *   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 *   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 *   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 *   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 *   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 *   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
/** A surface with no normals or no indices stays as it is, as Godot's guard at `:79` leaves it. */
export function flipFaces(surface) {
    const { normals, indices } = surface;
    if (!normals?.length || indices.length === 0)
        return surface;
    const flipped = Uint32Array.from(indices);
    for (let i = 0; i + 1 < flipped.length; i += 3)
        [flipped[i], flipped[i + 1]] = [flipped[i + 1], flipped[i]];
    return { ...surface, normals: normals.map((n) => -n), indices: flipped };
}
//# sourceMappingURL=flipFaces.js.map